export default {
  "content": "<title>map</title><path d=\"M15.3 21l-6.575-2.325L4.25 20.45a.798.798 0 01-.837-.025c-.275-.167-.413-.417-.413-.75V5.725c0-.217.063-.408.188-.575.124-.167.287-.292.487-.375L8.725 3 15.3 5.3l4.45-1.775a.858.858 0 01.837.038c.276.158.413.404.413.737v14.125a.67.67 0 01-.188.475 1.18 1.18 0 01-.462.3L15.3 21zm-.85-1.875V6.5l-4.9-1.65v12.625l4.9 1.65zm1.5 0l3.55-1.175V5.15L15.95 6.5v12.625zm-11.45-.3l3.55-1.35V4.85L4.5 6.025v12.8zM15.95 6.5v12.625V6.5zm-7.9-1.65v12.625V4.85z\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};